import { Component, OnInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ActivatedRoute } from '@angular/router';
import { ParametrosService } from 'src/app/services/parametros.service';

@Component({
  selector: 'app-agendamentostepper-client',
  templateUrl: './agendamentostepper-client.component.html',
  styleUrls: ['./agendamentostepper-client.component.scss']
})
export class AgendamentostepperClientComponent implements OnInit {
  smallScreen: boolean;
  defaultStepMode: String
  constructor(
    private breakpointObserver: BreakpointObserver,
    private activatedRoute: ActivatedRoute,
    private parametrosService: ParametrosService
  ) {

    breakpointObserver.observe([
      Breakpoints.XSmall,
      Breakpoints.Small
    ]).subscribe(result => {
      this.smallScreen = result.matches;
    });

    const agendamentoPadraoLoad: any = parametrosService.getParams('AGENDAMENTO_PADRAO') || { valor: 'false' }
    this.defaultStepMode = agendamentoPadraoLoad.valor
  }

  ngOnInit() {
  }
}
